//import _ from 'lodash'
import { ActionTypes } from '../actions'

const {
  FETCH_INITIAL_DATA_RECEIVED,
  SET_PUBLIC_HOLIDAYS,
} = ActionTypes

const oncall = (state = {}, action) => {
  switch (action.type) {
    case FETCH_INITIAL_DATA_RECEIVED:
      return {
        ...state,
        ...action.data,
      }
    case SET_PUBLIC_HOLIDAYS:
      return {
        ...state,
        public_holidays: action.public_holidays,
      }
    default:
      return state
  }
}

export default oncall
